import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  template: ''
})
export class EmptyPageComponent {}
